import { useState } from 'react'
import { toast } from 'sonner'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { Uploader } from '@/components/Uploader'
import { useAuth } from '@/hooks/useAuth'
import { adImageService } from '@/services/ad_image_service'
import { logger } from '@magnetar/utils'

interface UploadAdImageDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  supplierId: number
  onSuccess?: () => void
}

export default function UploadAdImageDialog({
  open,
  onOpenChange,
  supplierId,
  onSuccess,
}: UploadAdImageDialogProps) {
  const { token } = useAuth()
  const [uploaderKey, setUploaderKey] = useState(0)

  const handleUploadSuccess = async (result: { uuid: string }) => {
    if (!token) return

    try {
      const response = await adImageService.createAdImage(
        supplierId,
        { file_uuid: result.uuid, is_active: true },
        token,
      )

      if (response.success) {
        toast.success('廣告圖片已新增')
        setUploaderKey((prev) => prev + 1)
        onSuccess?.()
      } else {
        toast.error(response.error?.message || '新增廣告圖片失敗')
      }
    } catch (error) {
      logger.error('新增廣告圖片失敗', error)
      toast.error('新增廣告圖片失敗')
    }
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle>上傳廣告圖片</DialogTitle>
          <DialogDescription>支援 jpg、png、gif、webp 格式，上傳後可標記對應廣告並設定播放時長</DialogDescription>
        </DialogHeader>
        <Uploader
          key={uploaderKey}
          folder="ad-images"
          onUploadSuccess={handleUploadSuccess}
          allowedFileTypes={['.jpg', '.jpeg', '.png', '.gif', '.webp']}
          maxFileSize={20 * 1024 * 1024}
        />
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            關閉
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
